export default __webpack_public_path__ + "static/media/south-plains-solar-logo.c2a17984.png";